import { Observable, of } from 'rxjs';
import { HttpClient, HttpHeaders, HttpParams, HttpHandler } from '@angular/common/http';
import { TransferState, makeStateKey } from '@angular/core';
import { PLATFORM_ID, Injectable, Inject } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { catchError, tap } from 'rxjs/operators';

@Injectable()
export class EcapHttp extends HttpClient {
    private platformType: any;
    private isPlatformServer: boolean;

    constructor(private state: TransferState, @Inject(PLATFORM_ID) platformId: string, handler: HttpHandler) {
        super(handler);
        // console.log('=====EcapHttp INITIALIZED=====');
        this.platformType = platformId;
        this.isPlatformServer = isPlatformServer(platformId);
    }

    public _get(url: string, options?: {
        headers?: HttpHeaders;
        observe?: 'body';
        params?: HttpParams;
        reportProgress?: boolean;
        responseType?: 'json';
        withCredentials?: boolean;
    } | any): Observable<any> {
        // case when request is being made dring server side run
        if (this.isPlatformServer) {
            // console.log('case when request is being made during server side run');
            return this.setStateAndReturnGet(url, options);
        } else {
            const stateKey = makeStateKey(this.encryptUrl(url, ''));
            const savedData = this.state.get(stateKey, null as any);
            // console.log('trying to get key with ' + stateKey, savedData);
            // case when request is being made during client side run but server side state is preserved
            if (savedData !== null) {
                // console.log('case when request is being made during client side run but server side state is preserved');
                this.state.set(stateKey, null as any);
                return of(savedData);
            } else { // case when request is being made during client side run but server side state is no preserved
                // console.log('case when request is being made during client side run but server side state is no preserved');
                return super.get(url, options);
            }
        }
    }

    public setStateAndReturnGet(url: string, options: any): Observable<any> {
        // tslint:disable-next-line:no-//debugger
        //
        const stateKey = makeStateKey(this.encryptUrl(url, ''));
        return super.get(url, options).pipe(tap((val: any) => {
            this.state.set(stateKey, val as any);
        }), catchError((err: any) => {
            this.state.set(stateKey, err as any);
            throw err;
        }));
    }

    public _post(url: string, body: any | null, options: {
        headers?: HttpHeaders;
        observe?: 'body';
        params?: HttpParams;
        reportProgress?: boolean;
        responseType: 'arraybuffer';
        withCredentials?: boolean;
    } | any): Observable<ArrayBuffer> {
        // case when request is being made dring server side run
        if (this.isPlatformServer) {
            return this.setStateAndReturnPost(url, body, options);
        } else {
            const stateKey = makeStateKey(this.encryptUrl(url, body));
            // case when request is being made during client side run but server side state is preserved
            if (this.state.get(stateKey, null as any) !== null) {
                const savedData = this.state.get(stateKey, null as any);
                this.state.set(stateKey, null as any);
                return of(savedData);
            } else { // case when request is being made during client side run but server side state is no preserved
                return super.post(url, body, options);
            }
        }
    }

    public setStateAndReturnPost(url: string, body: any, options: any): Observable<any> {
        const stateKey = makeStateKey(this.encryptUrl(url, ''));
        return super.post(url, body, options).pipe(tap((val: any) => {
            this.state.set(stateKey, val as any);
        }), catchError((err: any) => {
            this.state.set(stateKey, err as any);
            throw err;
        }));
    }

    public encryptUrl(url: string, body: any) {
        return JSON.stringify(url + '|' + JSON.stringify(body));
    }
}
